import { OrderSendForm } from '@/types/order';
import { FormProvider, useForm } from 'react-hook-form';
import { CustomerInfo, Header, PickUpNotice, ServiceAgreement } from '@/components/OrderPage';
import { Cart } from '@/components/OrderPage/Cart';
import { useCart, useTimer } from '@/hooks';
import useLocalStorage from '@/hooks/useLocalStorage';
import { RecipientInfo } from '@/components/OrderPage/RecipientInfo';
import { useSearchParams } from 'react-router-dom';
import { receivingType } from '@/types/checkout';
import PageViewEvent from '@/components/Event/PageViewEvent';

export const initOrderForm = {
  // customer_first_name: '',
  // customer_last_name: '',
  // customer_country_code: '',
  // customer_country_code_number: '',
  // customer_phone_number: '',
  // customer_email_1: '',
  // customer_email_2: 'gmail.com',
  receiving_method: 'pick_up',

  same_as_above: false,
  residence_business_Hotel_etc: false,

  pickup_location: 'hongdae',

  service_agreement_1: false,
  service_agreement_2: false,

  company_address: '',
  company_address_po: '',

  shipping_info_first_name: '',
  shipping_info_last_name: '',
  shipping_info_country_code: '',
  shipping_info_country_code_number: '',
  shipping_info_phone_number: '',
  shipping_info_email_1: '',
  shipping_info_email_2: 'gmail.com',
  shipping_info_address_1: '',
  shipping_info_address_2: '',
  shipping_info_postal_code: '',
  shipping_info_city: '',
  shipping_info_state: '',
  shipping_info_memo: ''
};

const OrderPage = () => {
  const [localFormState] = useLocalStorage('local-form-state', initOrderForm);
  const [searchParams] = useSearchParams();
  const shippingType = (searchParams.get('shipping_method') ?? 'pick_up') as receivingType;
  const { ref } = useTimer();
  const { cartData } = useCart({ receivingMethod: shippingType });

  const method = useForm<OrderSendForm>({
    defaultValues: localFormState,
    mode: 'onChange'
  });

  const isShippingAvailable = (cartData?.offer_total ?? 0) >= 50000;
  const isGlobal = shippingType === 'global';

  return (
    <PageViewEvent
      eventName={'Order_view'}
      eventProps={{
        Receiving_method: shippingType
      }}
    >
      <div ref={ref}>
        <FormProvider {...method}>
          <div className="w-full h-full overflow-y-hidden flex justify-center max-h-screen no-scrollbar">
            <div className="relative flex-1 overflow-y-scroll max-h-screen">
              <Header />

              {/* Customer Info */}
              <CustomerInfo isGlobal={isGlobal} />

              {shippingType === 'pick_up' ? (
                <PickUpNotice isShippingAvailable={isShippingAvailable} />
              ) : (
                <RecipientInfo isGlobal={isGlobal} isShippingAvailable={isShippingAvailable} />
              )}

              {/* Service Agreement */}
              <ServiceAgreement />
            </div>

            {/* Cart */}
            <Cart />
          </div>
        </FormProvider>
      </div>
    </PageViewEvent>
  );
};

export default OrderPage;
